import { api } from "../../utils/api";

export async function getWhatsappConnection(connectionId) {
  try {
    // Como pode não ter endpoint específico, busca todas e filtra
    const response = await api.get(`/v2/whatsapp`);
    
    if (response.data && response.data.data) {
      const connection = response.data.data.find(conn => conn.id === connectionId);
      if (connection) {
        return {
          ...response.data,
          data: connection
        };
      }
    }
    
    throw new Error("Conexão não encontrada");
  } catch (error) {
    console.error("Erro ao buscar conexão do WhatsApp:", error);
    throw error;
  }
}
